/**
 * ParkingPayment API
 *
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UserLocationDto } from './userLocationDto';


export interface UserDto { 
    id?: number;
    email?: string | null;
    name?: string | null;
    lastName?: string | null;
    isActive?: boolean;
    userLocations?: Array<UserLocationDto> | null;
    roles?: Array<string> | null;
}

